export enum StabilityLevel {
  Stable = 'stable',
  Beta = 'beta',
  Experimental = 'experimental',
}
